import type { BaseOddsGridApiArgs } from './types';

export const isMissingUsRegionContext = ({
  countryCode,
  subdivision,
}: Pick<BaseOddsGridApiArgs, 'countryCode' | 'subdivision'>) => {
  // If no country code is provided, allow the request
  if (!countryCode) return false;
  // If the country code is not US, allow the request
  if (countryCode.toUpperCase() !== 'US') return false;

  // For US requests, if subdivision is missing, return true to indicate missing region context
  return !subdivision;
};
